import type { DefaultRemoteConfig, AppRemoteConfig } from './types';

/**
 * @description Default config to pass when initializing firebase/remote-config
 *
 * @see https://firebase.google.com/docs/remote-config/get-started?hl=en&authuser=0&platform=web#default-parameter-in-app
 */
const defaultRemoteConfig: DefaultRemoteConfig = {
  tours_maintenance_toaster: '',
};

const defaultAppRemoteConfig: AppRemoteConfig = {
  tours_maintenance_toaster: null,
};

export const firebaseConfig = {
  defaultRemoteConfig,
  defaultAppRemoteConfig,
};
